/* eslint-disable */
/**
 * Validation functions for EditVendorPageV2 component
 */
import { message } from 'antd';

/**
 * Get required fields for a specific step
 * @param {number} step - The step number
 * @param {object} formValues - Form values to check conditional requirements
 */
export const getRequiredFieldsForStep = (step, formValues = {}) => {
	switch (step) {
		case 0: // Basic Information
			return [
				'vendor_type',
				'vendor_name',
				'legal_structure',
				'vendor_email_id',
				'primary_poc_name',
				'primary_poc_contact',
				'vendor_address',
				'pincode',
				'city',
				'state',
			];
		case 1: {
			// Business Information
			const businessFields = [
				'pan_number',
				'pan_file_key',
				'gst_type',
				'aadhar_number',
				'aadhar_file_key',
			];
			// GST number and file key are only required if GST type is NOT "Unregistered"
			if (formValues.gst_type && formValues.gst_type !== 'Unregistered') {
				businessFields.push('gst_number', 'gst_file_key');
			}
			return businessFields;
		}
		case 2: // Banking Information
			return [
				'account_holder_name',
				'account_number',
				'bank_name',
				'ifsc_code',
				'branch_name',
				'bank_document_key',
				'vrf_document_key',
			];
		case 3: // Vehicle Information
			return []; // No required fields for vehicle step
		case 4: // Serviceability Info
			return []; // No required fields for serviceability step
		default:
			return [];
	}
};

/**
 * Validate required fields for the current editable step only
 */
export const validateRequiredFields = (formValues, step) => {
	// If no step specified or step is null, validate all fields (create mode behavior)
	if (step === null || step === undefined) {
		const allRequiredFields = [
			'vendor_type',
			'vendor_name',
			'legal_structure',
			'vendor_email_id',
			'primary_poc_name',
			'primary_poc_contact',
			'vendor_address',
			'pincode',
			'city',
			'state',
			'pan_number',
			'pan_file_key',
			'gst_type',
			'aadhar_number',
			'aadhar_file_key',
			'account_holder_name',
			'account_number',
			'bank_name',
			'ifsc_code',
			'branch_name',
			'bank_document_key',
			'vrf_document_key',
		];

		// GST number and file key are only required if GST type is NOT "Unregistered"
		if (formValues.gst_type && formValues.gst_type !== 'Unregistered') {
			allRequiredFields.push('gst_number', 'gst_file_key');
		}

		const missingFields = allRequiredFields.filter((field) => {
			const value = formValues[field];
			return (
				value === undefined ||
				value === null ||
				value === '' ||
				(typeof value === 'string' && value.trim() === '')
			);
		});

		if (missingFields.length > 0) {
			message.error(
				`Please fill in all required fields. Missing: ${missingFields.join(', ')}`
			);
			return false;
		}
		return true;
	}

	// In edit mode, only validate the current editable step
	const requiredFields = getRequiredFieldsForStep(step, formValues);

	if (requiredFields.length === 0) {
		return true; // No required fields for this step
	}

	const missingFields = requiredFields.filter((field) => {
		const value = formValues[field];
		return (
			value === undefined ||
			value === null ||
			value === '' ||
			(typeof value === 'string' && value.trim() === '')
		);
	});

	if (missingFields.length > 0) {
		message.error(
			`Please fill in all required fields for this step. Missing: ${missingFields.join(', ')}`
		);
		return false;
	}
	return true;
};
/**
 * Validate MSME fields and VRF document (VRF is independent of MSME)
 */
export const validateMSMEFields = (formValues, step) => {
	// Only validate on Basic Information (step 0) or Banking step (step 2)
	if (step !== 0 && step !== 2) {
		return true;
	}

	// VRF document is always required on Banking step (step 2)
	if (step === 2 && !formValues.vrf_document_key) {
		message.error('Please upload the VRF document');
		return false;
	}

	// msme_number is required only when vendor_registered_msme is true
	if (formValues.vendor_registered_msme) {
		if (
			!formValues.msme_number ||
			(typeof formValues.msme_number === 'string' && formValues.msme_number.trim() === '')
		) {
			message.error('MSME Number is required when vendor is registered as MSME');
			return false;
		}
	}

	return true;
};
